import styled from "styled-components";
import hashSigningImage from "../../../images/hash-signing-image.png";

const CenterPreviews = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 auto;
`;

const Image = styled.img`
  width: 200px;
  height: 200px;
  display: block;
  object-fit: contain;
`;

export default function HashSigningImage(): JSX.Element {
  return (
    <CenterPreviews data-testid="hash_signing_image">
      <Image src={hashSigningImage} alt="" />
    </CenterPreviews>
  );
}
